import React from 'react';
import { ArrowUpRightIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { assets, business, mailtoHref, mapsHref, preparationList } from '../data/content';
import { SectionLabel } from './SectionLabel';
export function Contact() {
  return <section id="contact" aria-labelledby="contact-heading" className="ink-surface relative w-full bg-ink py-20 lg:py-28" data-id="element-22" data-mp="316tqdgkaj18x">
      <img src={assets.fenceAlt} alt="" aria-hidden="true" width={1328} height={747} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover opacity-20" data-id="element-23" data-mp="3sy98oyete1tc" />
      <div aria-hidden="true" className="absolute inset-0 bg-ink/85" data-id="element-24" data-mp="3k3bfdq7r8n1h" />

      <div className="relative mx-auto max-w-shell px-5 lg:px-8" data-id="element-25" data-mp="3f5jp10mrd8ze">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-26" data-mp="ggulxh2gfab2">
          <div className="lg:col-span-7" data-id="element-27" data-mp="bpmc4jx7pmxd">
            <SectionLabel number="06" tone="light" data-id="element-28" data-mp="bokyq8sq4och">
              Contact
            </SectionLabel>
            <h2 id="contact-heading" className="mt-5 font-display text-[38px] font-semibold uppercase leading-[1.0] text-white sm:text-[52px] lg:text-[62px]" data-id="element-29" data-mp="3jwmd2sx39r5r">
              Let&rsquo;s talk through your project.
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-steel-300 sm:text-lg" data-id="element-30" data-mp="3f4mep4wo36ba">
              Reach our team directly by phone or email. Send what you have — plans, specifications
              or a site address — and we&rsquo;ll work through the perimeter requirements with you.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-31" data-mp="2s56s13b6kchn">
              <a href="#project-inquiry" className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-sm bg-safety px-7 font-display text-lg uppercase tracking-[0.08em] text-ink transition-colors duration-150 ease-industrial hover:bg-safety-600" data-id="element-32" data-mp="2s6rjgk277fba">
                <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-33" data-mp="23bc3l41y8hzi" />
                Send Your Project Details
              </a>
              <a href={business.phoneHref} className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-sm border border-steel-300/70 px-7 font-display text-lg uppercase tracking-[0.08em] text-white transition-colors duration-150 ease-industrial hover:border-safety hover:text-safety" data-id="element-34" data-mp="1ybfw2uu1m8f7">
                <PhoneIcon aria-hidden="true" className="h-4 w-4" data-id="element-35" data-mp="2m3wjzm0goumf" />
                Call {business.phone}
              </a>
            </div>

            <dl className="mt-12 grid grid-cols-1 gap-8 border-t border-white/15 pt-8 sm:grid-cols-2" data-id="element-36" data-mp="2d8q6e0uy989c">
              <div data-id="element-37" data-mp="289m13lb5buoa">
                <dt className="font-display text-[13px] uppercase tracking-[0.2em] text-steel-300" data-id="element-38" data-mp="28a5eqptrjwwi">
                  Phone
                </dt>
                <dd className="mt-2 space-y-1 text-base text-white" data-id="element-39" data-mp="30zm57hxtp3q3">
                  <a href={business.phoneHref} className="block transition-colors duration-150 ease-industrial hover:text-safety" data-id="element-40" data-mp="30x9h0n1h1x4l">
                    {business.phone}
                  </a>
                  <a href={business.tollFreeHref} className="block transition-colors duration-150 ease-industrial hover:text-safety" data-id="element-41" data-mp="3i8ey8j1v90b2">
                    {business.tollFree} <span className="text-steel-300" data-id="element-42" data-mp="3r8jvw1h9ckc1">(toll free)</span>
                  </a>
                </dd>
              </div>
              <div className="sm:col-span-2 sm:order-last" data-id="element-43" data-mp="z09q4lstit">
                <dt className="font-display text-[13px] uppercase tracking-[0.2em] text-steel-300" data-id="element-44" data-mp="4uthmmwqkweq">
                  Email
                </dt>
                <dd className="mt-2 text-base text-white" data-id="element-45" data-mp="9uo6ym0v5dxo">
                  <a href={mailtoHref} className="break-words transition-colors duration-150 ease-industrial hover:text-safety" data-id="element-46" data-mp="dvrm16b375xu">
                    {business.email}
                  </a>
                </dd>
              </div>
              <div data-id="element-47" data-mp="160ok8tgudu7">
                <dt className="font-display text-[13px] uppercase tracking-[0.2em] text-steel-300" data-id="element-48" data-mp="14poaiz8bo7u">
                  Address
                </dt>
                <dd className="mt-2 text-base text-white" data-id="element-49" data-mp="9xj9ex1cxhtm">
                  <a href={mapsHref} target="_blank" rel="noopener noreferrer" className="inline-flex items-start gap-2 transition-colors duration-150 ease-industrial hover:text-safety" data-id="element-50" data-mp="9y2mo0g2bi1b">
                    <MapPinIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0" data-id="element-51" data-mp="3scblptvcuug9" />
                    <span data-id="element-52" data-mp="3nbe4bji664ft">
                      {business.address.street}
                      <br data-id="element-53" data-mp="17krxmzsqt4zb" />
                      {business.address.city}, {business.address.state} {business.address.zip}
                    </span>
                  </a>
                </dd>
              </div>
            </dl>
          </div>

          <div className="lg:col-span-5" data-id="element-54" data-mp="2kia1mq4alpwc">
            <div className="border border-white/15 bg-ink-700/60 p-7" data-id="element-55" data-mp="2piwkluighv2x">
              <h3 className="font-display text-[22px] font-semibold uppercase leading-tight text-white" data-id="element-56" data-mp="2pgtn6pez4zo6">
                Helpful to have on hand
              </h3>
              <ul className="mt-5 space-y-3 text-[15px] leading-relaxed text-steel-300" data-id="element-57" data-mp="2gj9jzaxjwtax">
                {preparationList.map(item => <li key={item} className="flex gap-3" data-id="element-58" data-mp="349x3yukqr9du">
                    <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 bg-safety" data-id="element-59" data-mp="388cpsv536bpo" />
                    <span data-id="element-60" data-mp="2ugy76pf3ccj5">{item}</span>
                  </li>)}
              </ul>
              <p className="mt-6 border-t border-white/15 pt-5 text-sm leading-relaxed text-steel-300" data-id="element-61" data-mp="2zg2dn8amrw5s">
                Partial information is fine — a location and a rough layout is enough to start the
                conversation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}